import { render, staticRenderFns } from "./AdminTableCopyTextButton.vue?vue&type=template&id=b82d2fda&scoped=true&"
import script from "./AdminTableCopyTextButton.vue?vue&type=script&lang=js&"
export * from "./AdminTableCopyTextButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82d2fda",
  null
  
)

export default component.exports